import Http from '@/services/httpAcademy'

export const listCommissions   = (params)           => Http.get('/admin/commissions', { params })
export const createCommission  = (data)             => Http.post('/admin/commissions', data)
export const updateCommission  = ({ id, ...data })  => Http.patch(`/admin/commissions/${id}`, data)
export const deleteCommission  = (id)               => Http.delete(`/admin/commissions/${id}`)
